export const PHONE_NUMBER_MAX_LENGTH = 9;
export const DOCUMENT_TYPE_MAX_LENGTH = 25;
export const FULL_NAME_MAX_LENGTH = 75;
export const EMAIL_MAX_LENGTH = 75;
export const JOB_MAX_LENGTH = 25;
export const DOCUMENT_NUMBER_MAX_LENGTH = 20;
export const ADDRESS_MAX_LENGTH = 75;
export const CONTACT_NAME_MAX_LENGTH = 75;
export const SUNARP_NUMBER_MAX_LENGTH = 20;
export const CONTACT_PHONE_NUMBER_MAX_LENGTH = 9;
export const PASSPORT_NUMBER_MAX_LENGTH = 20;
export const PASSPORT_NUMBER_MIN_LENGTH = 9;
export const TYPE_PASSPORT_NUMBER_MIN_LENGTH = 8;
export const DOCUMENT_DNI_MAX_LENGTH = 8;
export const DAY_SUM_TOTAL = 1;
export const ITEMS_PER_PAGE = 8;
export const NUMBER_DIGITS_FORGOT_PASSWORD_CODE = 6;
export const LOADING_SIZE_RUCS = 4;

export const DAM_MAX_LENGTH = 6;
export const RUC_MAX_LENGTH = 11;
export const DAM_EXTENSION_TWO_MAX_LENGTH = 2;
export const DAM_EXTENSION_ONE_MAX_LENGTH = 1;

export const REDUCE_DAYS = -1095;
export const INTERVAL_30_SECONDS = 30000;
export const INTERVAL_3_SECONDS = 3000;
export const INTERVAL_10_SECONDS = 10000;

export const ERROR_CUSTOMER_DATE = "ErrorscustomDatePicker";

export const CITATION_REPORT = "citation_report";
export const FLYERS_REPORT = "flyers_report";
export const TRACKING_REPORT = "tracking_report";

export const YYYY_MM_DD = "yyyy-MM-dd";
export const DD_MMM_YYYY = "dd MMM. yyyy";
export const DD_MMM_YYYY_HH_MM = "dd MMM. yyyy HH:mm";
export const DD_MMM_YYYY_HH_MM_HRS = "dd/MM/yyyy HH:mm 'hrs'";
export const DD_MM_YY = "dd/mm/yy";

export const DATE_FULL_YEAR = new Date().getFullYear();
export const DATE_FULL_YEAR_LESS_1 = 1;
export const DATE_FULL_YEAR_LESS_2 = 2;
export const DATE_FULL_YEAR_LESS_3 = 3;
export const DATE_FULL_YEAR_LESS_4 = 4;

export const SUCCESS = "SUCCESS";
export const PROCESSING = "PROCESSING";
export const NULL = "NULL";

export const PASSWORD_CREATE_USER = "T@lmaclick2023!";
